import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass, NgFor } from '@angular/common';
import { FormPill } from '../../../models/shared/form-pill';

@Component({
  selector: 'app-pill-picker-input',
  templateUrl: './pill-picker-input.component.html',
  styleUrls: ['./pill-picker-input.component.scss'],
  standalone: true,
  imports: [NgClass, NgFor],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PillPickerInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class PillPickerInputComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() controlId: string | null = null;
  @Input() pills: FormPill[] = [];
  @Input() hasError: boolean = false;
  @Output() valueChange = new EventEmitter<FormPill | null>();

  public value: FormPill[] | null = null;
  public disabled: boolean = false;

  private onChange: (value: FormPill[] | null) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: FormPill[] | null): void {
    if (!value) {
      this.pills?.forEach(p => (p.selected = false));
      this.value = null;
    } else {
      this.pills?.forEach(p => {
        p.selected = value.some(v => v.id === p.id);
      });
      this.value = value.filter(pill => pill.selected);
    }
  }

  public pillSelected(pill: FormPill): void {
    if (this.disabled) return;

    pill.selected = !pill.selected;
    this.valueChange.emit(pill);
    this.onChange(this.pills.filter(p => p.selected));
    this.onTouched();
  }

  public registerOnChange(fn: (value: FormPill[] | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
